class SecondaryMenuUpdater {
  static setActive(linkItem: string) {
    const elements = document.getElementsByClassName('secondary-nav-menu-item')
    for (let i = 0; i < elements.length; i++) {
      if (!elements[i].classList.contains(linkItem)) {
        elements[i].classList.remove('selected')
      } else if (!elements[i].classList.contains('selected')) {
        elements[i].classList.add('selected')
      }
    }
  }
}

export default SecondaryMenuUpdater
